import { createFileRoute, redirect } from '@tanstack/react-router';
import { parse, object, optional, picklist, string, array, number } from 'valibot';

import { getUserPermissions, hasPermission, APP_PERMISSIONS } from '@/lib/auth/permissions';

export const Route = createFileRoute('/(authenticated)/dashboard')({
  validateSearch: (search) => {
    return parse(
      object({
        view: optional(picklist(['queue', 'my-referrals'])),
        search: optional(string()),
        status: optional(
          array(picklist(['pending', 'qualified', 'in_progress', 'enrolled', 'declined'])),
        ),
        program: optional(array(string())),
        task_status: optional(
          array(picklist(['not_started', 'in_progress', 'completed', 'overdue', 'blocked'])),
        ),
        assigned_to: optional(number()),
        page: optional(number()),
        limit: optional(number()),
        sort_by: optional(string()),
        sort_order: optional(picklist(['asc', 'desc'])),
        referral_id: optional(number()),
        task_id: optional(number()),
        callCenter: optional(
          object({
            taskId: number(),
            referralId: number(),
          }),
        ),
        callCenterFhir: optional(
          object({
            taskId: string(),
            serviceRequestId: string(),
          }),
        ),
      }),
      search,
    );
  },
  beforeLoad: async ({ search }) => {
    const { permissions } = await getUserPermissions();

    const hasEnrollment = hasPermission(permissions, APP_PERMISSIONS.PATIENT_ENROLLMENT);
    const hasAdmin = hasPermission(permissions, APP_PERMISSIONS.ADMIN_DASHBOARD);
    const isEnrollmentOnly = hasEnrollment && !hasAdmin;

    if (isEnrollmentOnly && !search.view) {
      throw redirect({
        to: '/dashboard',
        search: { ...search, view: 'queue' },
        replace: true,
      });
    }

    if (!hasEnrollment && search.view) {
      const { view: _, ...searchWithoutView } = search;
      throw redirect({
        to: '/dashboard',
        search: searchWithoutView,
        replace: true,
      });
    }
  },
});
